<template>
  <div class='tour'>
    <h1 class='daytour'>5 DAYS IN 5 NATIONAL PARKS</h1>
    <div class='tourPic'>
      <img src='@/assets/multidaytours/tour2/01.jpg' />
    </div>
    <div>
      <ul class='fa-ul'>
        <li>
          <span class='fa-li'
            ><img
              style='width: 35px; margin-left: 0px; margin-top: 0px'
              src='@/assets/logo/lovcen-green.png'
          /></span>
          <a data-toggle='collapse' href='#tourDescription'
            ><h4 class='titles'>Tour description</h4></a
          >
          <div class='collapse' id='tourDescription'>
            <p class='pasus'>
              The theme of this 5-days tour is national parks of Montenegro,
              each of which is a story in itself and area of unique quality.
              Around 10% of Montenegro’s territory is protected by law because
              of its natural and cultural values. Montenegro is a first country
              in the world to proclaim itself ecological state in 1991 by
              writing it down in the first article of its Constitution.
            </p>
            <p class='pasus'>
              National parks are far-known for its natural attributes – Durmitor
              for its geomorphology, glacial lakes and deep canyons, Biogradska
              Gora for its primeval untouched forest, one of the three of such
              kind remaining in Europe, which surrounds the beautiful glacial
              lake, Prokletije for its impressive mountain peaks and valleys,
              hydro phenomena and rich diversity, Lovcen for its spectacular
              viewpoints, abundant flora and cultural heritage and finally
              Skadar Lake for its diverse flora and fauna, rich cultural
              heritage and villages of unique architecture and aesthetic values.
            </p>
            <p class='pasus'>
              The tour starts in national park Skadar Lake situated only a few
              meters above the sea level and finishes with a spectacular view
              from almost 2000 meters above sea level in national park Durmitor.
            </p>
            <p class='pasus'>
              Most of the time on this tour will be spent away from crowds – we
              will be surrounded by unique landscapes, in different parts of
              Montenegro, close to the sea and lakes but also in forests, taking
              a stroll around glacial lakes, mountain valleys and passes, near
              rivers, always near rivers…
            </p>
            <p class='pasus'>
              In terms of physical requirements, the tour is not difficult. We
              will make sure to walk as much as you feel comfortable and spend
              time in different places as much as you want it without disrupting
              the program we agreed. This tour will give you an opportunity to
              get to know the border areas of Montenegro, inhabited by
              minorities, where different cultures permeate and Islam and
              Orthodoxy coexist in harmony.
            </p>
            <p class='pasus'>
              You will spend time in regions famous for its dairy specialties,
              quality lamb, veal and freshwater fish in addition to homegrown
              fruits and vegetables. You will have a chance to taste
              Montenegro’s famous smoked ham, red wine, mead and brandy.
            </p>
            <p class='pasus'>
              And local people will always welcome you with kindness and pride.
            </p>
            <p class='pasus'>Cheers!</p>
          </div>
        </li>
        <li>
          <span class='fa-li'
            ><img
              style='width: 35px; margin-left: 0px; margin-top: 0px'
              src='@/assets/logo/lovcen-green.png'
          /></span>
          <a data-toggle='collapse' href='#tourDetails'
            ><h4 class='titles'>Tour details</h4></a
          >
          <div class='collapse' id='tourDetails'>
            <p class='pasus'>Type of tour: Private</p>
            <p class='pasus'>Availability: May - October</p>
            <p class='pasus'>Group size: 1-7</p>
            <p class='pasus'>Departure from: Podgorica</p>
            <p class='pasus'>Difficulty level: easy</p>
            <p class='pasus'>Duration: 5 nights / 6 days</p>
          </div>
        </li>
        <li>
          <span class='fa-li'
            ><img
              style='width: 35px; margin-left: 0px; margin-top: 0px'
              src='@/assets/logo/lovcen-green.png'
          /></span>
          <h4 class='titles'>Highlights</h4>
          <vue-picture-swipe :items='items'></vue-picture-swipe>
        </li>
        <li>
          <span class='fa-li'
            ><img
              style='width: 35px; margin-left: 0px; margin-top: 0px'
              src='@/assets/logo/lovcen-green.png'
          /></span>
          <a data-toggle='collapse' href='#itinerary'
            ><h4 class='titles'>Itinerary</h4></a
          >
          <ul class='collapse itinerary_days' id='itinerary'>
            <li>
              <a data-toggle='collapse' href='#day1'>
                <h5 class='sub-titles'>
                  Day 1 - National park Skadar Lake- Among birds and water
                  lilies
                </h5></a
              >
              <div class='collapse' id='day1'>
                <p class='pasus'>
                  Upon your arrival at Podgorica airport, the driver/guide will
                  meet you at the exit hall carrying a welcome sign with your
                  name. After a short introduction you will head towards Skadar
                  Lake national park. Spending time near water and enjoying easy
                  boat ride on a clam lake will be a perfect relaxation after
                  your flight. Surrounded by water lilies, reed and birds you
                  will soon feel harmony with nature.
                </p>
                <p class='pasus'>
                  Skadar Lake has been the inhabited area for millenniums
                  encompassing some 50 islands with important cultural and
                  historical monuments, monasteries and fortresses and old
                  fishing villages of traditional architecture resting on its
                  shores.
                </p>
                <p class='pasus'>
                  Once we complete the boat ride, we will enjoy the views from
                  the lake lookouts, pay a visit to Godinje village known for
                  its unique architecture and wine and finally see a fortress
                  dating back to the beginning of Ottoman occupation of this
                  part of Montenegro.
                </p>
                <p class='pasus'>
                  It would indeed be a pity not to taste some well-known fish
                  delicacies of this region and its famous wine.
                </p>
                <p class='pasus'>Accommodation: 4 - star hotel in Podgorica</p>
                <div class='tour-time'>
                  <p> <i class='fas fa-clock'></i> 1 hour 20 minutes</p>
                  <p> <i class='fas fa-route'></i> 70 km</p>
                </div>
                <img
                  class='daypic'
                  src='@/assets/multidaytours/tour2/day1.jpg'
                />
              </div>
            </li>
            <li>
              <a data-toggle='collapse' href='#day2'>
                <h5 class='sub-titles'>
                  Day 2 - National Park Lovcen – Glorious Montenegrin history
                  and “Montenegrin Olimp”
                </h5></a
              >
              <div class='collapse' id='day2'>
                <p class='pasus'>
                  The second day of our tour is reserved for Lovcen national
                  park and the mountain of the same name – the symbol of
                  Montenegro’s independence, fight for freedom and region known
                  for its natural values, spectacular lookouts, the highest
                  mausoleum in the world, beech forest…
                </p>
                <p class='pasus'>
                  On our way to the national park, we won’t miss the chance to
                  once again enjoy the lake panorama from the popular lookout at
                  Pavlova strana, and soon after take a walk through a charming
                  small town Rijeka Crnojevica. The rest of the day we will
                  spend getting to know “Montenegrin Olimp” and its natural and
                  cultural values. We will take a walk through beech forest at
                  Ivanova korita resort, drink water from the most famous
                  Montenegrin spring, climb up 461 stairs to reach the highest
                  mausoleum in the world, enjoy the view on one of the most
                  beautiful bays in the world – Boka Bay, pay a visit to the
                  most celebrated Montenegrin village Njegusi, the cradle of the
                  most significant Petrovic dynasty, taste Montenegrin smoked
                  ham – a national brand.
                </p>
                <p class='pasus'>Accommodation: 4 - star hotel in Podgorica</p>
                <div class='tour-time'>
                  <p> <i class='fas fa-clock'></i> 2.5 hours</p>
                  <p> <i class='fas fa-route'></i> 125 km</p>
                </div>
                <img
                  class='daypic'
                  src='@/assets/multidaytours/tour2/day2.jpg'
                />
              </div>
            </li>
            <li>
              <a data-toggle='collapse' href='#day3'
                ><h5 class='sub-titles'>
                  Day 3 - National Park Biogradska Gora – Glacial lake and
                  primeval forest
                </h5></a
              >
              <div class='collapse' id='day3'>
                <p class='pasus'>
                  The third day of our tour is time to refresh and move to the
                  northern region of Montenegro, spend time at higher altitudes,
                  lower temperatures and in greener environment.
                </p>
                <p class='pasus'>
                  On our way to Biogradska Gora national park, we will pass
                  through the spectacular Moraca River canyon around 1000 meters
                  deep, visit the famous Moraca monastery to reach the heart of
                  the park – the gorgeous Biogradsko Lake, at noon. We will take
                  a stroll around the glacial lake, down a 3km long path,
                  through primeval untouched forest, one of only three of such
                  kind in Europe, meet the park’s impressive flora, admire 400
                  years old trees, take a boat ride if so wished, see a
                  visitors’ center and find out more about park’s fauna and
                  cultural heritage of the area.
                </p>
                <p class='pasus'>
                  During the rest of the day we may visit local farm and taste
                  local cheese or take the ski lift to one of Bjelasica Mountain
                  peaks and enjoy the view from above.
                </p>
                <p class='pasus'>
                  Accommodation: 4- star hotel in Kolasin or Berane
                </p>
                <div class='tour-time'>
                  <p> <i class='fas fa-clock'></i> 2 hours 15 minutes</p>
                  <p> <i class='fas fa-route'></i> 110 km</p>
                </div>
                <img
                  class='daypic'
                  src='@/assets/multidaytours/tour2/day3.jpg'
                />
              </div>
            </li>
            <li>
              <a data-toggle='collapse' href='#day4'
                ><h5 class='sub-titles'>
                  Day 4 - National Park Prokletije - Accursed Mountain & hydro
                  phenomena
                </h5></a
              >
              <div class='collapse' id='day4'>
                <p class='pasus'>
                  Today we are on our way to the youngest national park but
                  before we reach its alpine slopes we will see the greatest
                  glacial lake – Plavsko Lake, where springs of river Lim are,
                  take a walk to the lake shore and enjoy the view on cultivated
                  slopes of surrounding mountains listening to the song of lake
                  birds, and pay a visit to the only botanical garden in this
                  part of the country.
                </p>
                <p class='pasus'>
                  While in the park, we will see the most prominent karst spring
                  in this part of Montenegro – Ali Pasini springs, walk to
                  another water gem known for its enchanting color and enjoy the
                  view on jagged peaks of Prokletije massif.
                </p>
                <p class='pasus'>
                  On our way back we will get to know the pearl of oriental
                  architecture, the famous Redzepagica tower, pass through
                  pretty villages surrounding Plavsko Lake.
                </p>
                <p class='pasus'>
                  Accommodation: 4 - star hotel in Kolašin or Berane
                </p>
                <div class='tour-time'>
                  <p> <i class='fas fa-clock'></i> 3.5 hours</p>
                  <p> <i class='fas fa-route'></i> 200 km</p>
                </div>
                <img
                  class='daypic'
                  src='@/assets/multidaytours/tour2/day4.jpg'
                />
              </div>
            </li>
            <li>
              <a data-toggle='collapse' href='#day5'
                ><h5 class='sub-titles'>
                  Day 5 - National Park Durmitor – UNESCO, Tear of Europe, black pine
                  and Black Lake
                </h5></a
              >
              <div class='collapse' id='day5'>
                <p class='pasus'>
                  It is time to complete exploring the Montenegrin natural gems
                  by visiting the most famous national park – Durmitor,
                  protected as world natural heritage, with one of the deepest
                  canyons in the world (1330m), 17 glacial lakes and unique
                  geomorphological values.
                </p>
                <p class='pasus'>
                  We will touch clear waters of Tara river, walk through the old
                  black pine forest, cross over the spectacular Tara bridge (165
                  m high), try out one of the longest zip line in Europe if
                  preferred, enjoy the view on the deepest part of the Tara
                  canyon and finally, take a walk by the largest glacial lake -
                  the glorious Black Lake.
                </p>
                <p class='pasus'>We are back in Podgorica in the evening.</p>
                <p class='pasus'>Accommodation: 4 star hotel - Podgorica</p>
                <div class='tour-time'>
                  <p> <i class='fas fa-clock'></i> 3 hours 45 minutes</p>
                  <p> <i class='fas fa-route'></i> 210 km</p>
                </div>
                <img
                  class='daypic'
                  src='@/assets/multidaytours/tour2/day5.jpg'
                />
              </div>
            </li>
            <li>
              <a data-toggle='collapse' href='#day6'
                ><h5 class='sub-titles'>Day 6 - Departure day</h5></a
              >
              <div class='collapse' id='day6'>
                <p class='pasus'>
                  On your last day, you will have breakfast as usual after which
                  our driver will pick you up and take you directly to the
                  airport.
                </p>
              </div>
            </li>
            <li>
              <p class='pasus'>TOUR DATES: On request</p>
            </li>
          </ul>
        </li>
        <li>
          <span class='fa-li'
            ><img
              style='width: 35px; margin-left: 0px; margin-top: 0px'
              src='@/assets/logo/lovcen-green.png'
          /></span>
          <a data-toggle='collapse' href='#prices'>
            <h4 class='titles'>
              PRICE: based on the number of people in your group
            </h4></a
          >
          <div class='collapse' id='prices'>
            <ul class='square'>
              <li>1400 euro per person when two traveling</li>
              <li>1300 euro per person when four traveling</li>
              <li>1050 euro per person when six traveling</li>
              <li>For bigger groups on request</li>
              <li>Single room supplement: 200 EUR</li>
            </ul>
          </div>
        </li>
        <li>
          <span class='fa-li'
            ><img
              style='width: 35px; margin-left: 0px; margin-top: 0px'
              src='@/assets/logo/lovcen-green.png'
          /></span>
          <a data-toggle='collapse' href='#included'>
            <h4 class='titles'>What is included in the price</h4></a
          >
          <div class='collapse' id='included'>
            <ul class='square'>
              <li class='pasus'>Accommodation for all nights</li>
              <li class='pasus'>Transportation (van or car)</li>
              <li class='pasus'>Breakfast and dinner for all days</li>
              <li class='pasus'>Pick up at the airport</li>
              <li class='pasus'>Transfer to the airport on the last day</li>
              <li class='pasus'>Bottle of water - 0,5l each day</li>
              <li class='pasus'>Private boat tour on Skadar Lake (2h)</li>
              <li class='pasus'>
                Entrance fees for national parks and mausoleum
              </li>
              <li class='pasus'>Our assistance 24/7</li>
              <li class='pasus'>Licensed Tour Guide</li>
              <li class='pasus'>Travel map of Montenegro</li>
            </ul>
          </div>
        </li>
        <li>
          <span class='fa-li'
            ><img
              style='width: 35px; margin-left: 0px; margin-top: 0px'
              src='@/assets/logo/lovcen-green.png'
          /></span>
          <a data-toggle='collapse' href='#notincluded'>
            <h4 class='titles'>Not included in price</h4></a
          >
          <div class='collapse' id='notincluded'>
            <ul class='square'>
              <li>Options as mentioned</li>
              <li>Lunches, drinks and tips</li>
              <li>Personal expenses</li>
            </ul>
          </div>
        </li>
        <li>
          <span class='fa-li'
            ><img
              style='width: 35px; margin-left: 0px; margin-top: 0px'
              src='@/assets/logo/lovcen-green.png'
          /></span>
          <a data-toggle='collapse' href='#info'>
            <h4 class='titles'>Practical info</h4></a
          >
          <div class='collapse' id='info'>
            <ul class='square'>
              <li class='pasus'>
                We recommend that you always carry a jacket, a cap, sunglasses
                and shoes adequate to mountain conditions and a bathing suit.
                Weather conditions in the mountains frequently vary.
              </li>
              <li class='pasus'>
                The altitude difference we make is around 1900 meters. We start
                at 50 meters above sea level and the highest point we reach is
                at 1900 meters above sea level.
              </li>
              <li class='pasus'>
                Prices at restaurants and cafes are very affordable.
              </li>
              <li class='pasus'>The currency is euro.</li>
            </ul>
          </div>
        </li>
        <li>
          <span class='fa-li'
            ><img
              style='width: 35px; margin-left: 0px; margin-top: 0px'
              src='@/assets/logo/lovcen-green.png'
          /></span>
          <a data-toggle='collapse' href='#optional'>
            <h4 class='titles'>Optional</h4></a
          >
          <div class='collapse' id='optional'>
            <ul class='square'>
              <li class='pasus'>Wine tasting</li>
              <li class='pasus'>Panoramic ski lift ride</li>
              <li class='pasus'>Additional walks during the tour</li>
              <li class='pasus'>
                Itinerary changes during the tour can be agreed (do not affect
                the price)
              </li>
              <li class='pasus'>
                Zip line over Tara canyon (ticket price = 20 EUR)
              </li>
              <li class='pasus'>
                Boat ride on Biogradsko or Black Lake (1h = 8 EUR).
              </li>
            </ul>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
// import VuePictureSwipe from 'vue-picture-swipe';
export default {
  data () {
    return {
      items: [
        {
          src: require('@/assets/multidaytours/tour2/h1.jpg'),
          thumbnail: require('@/assets/multidaytours/tour2/h1.jpg'),
          w: 0,
          h: 720
        },
        {
          src: require('@/assets/multidaytours/tour2/h2.jpg'),
          thumbnail: require('@/assets/multidaytours/tour2/h2.jpg'),
          w: 0,
          h: 720
        },
        {
          src: require('@/assets/multidaytours/tour2/h3.jpg'),
          thumbnail: require('@/assets/multidaytours/tour2/h3.jpg'),
          w: 0,
          h: 720
        },
        {
          src: require('@/assets/multidaytours/tour2/h4.jpg'),
          thumbnail: require('@/assets/multidaytours/tour2/h4.jpg'),
          w: 0,
          h: 720
        },
        {
          src: require('@/assets/multidaytours/tour2/h5.jpg'),
          thumbnail: require('@/assets/multidaytours/tour2/h5.jpg'),
          w: 0,
          h: 720
        },
        {
          src: require('@/assets/multidaytours/tour2/h6.jpg'),
          thumbnail: require('@/assets/multidaytours/tour2/h6.jpg'),
          w: 0,
          h: 720
        }
      ]
    }
  }
}
</script>

<style scoped>
h1 {
  background-color: rgba(113, 186, 107, 0.9);
  border-radius: 3px;
  padding: 5px;
}
ul.square {
  list-style-type: square;
  text-align: left;
}
ul.none {
  list-style-type: none;
  text-align: left;
}

.tourPic {
  margin-top: 5vh;
  width: 100%;
}
.tourPic img {
  width: 100%;
}
.tour {
  padding-left: 10vw;
  padding-right: 10vw;
  padding-top: 15vh;
}
.daypic {
  width: 60vw;
  margin-bottom:20px;
}
.pasus {
  text-align: justify;
}
.row {
  display: flex;
  flex-wrap: wrap;
  padding: 0 4px;
}

.cont {
  position: relative;
  text-align: center;
  color: white;
}
.link {
  text-decoration: none;
}
.daytrips {
  padding-top: 10vw;
}
</style>



// WEBPACK FOOTER //
// src/components/MT2_NationalParks.vue